import type {
  ClientResponse,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/volunteer-group'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/v4/volunteer-group'
import type { VolunteerGroupParameters } from '@onhandtech/onhand-fe-shared/lib/contracts/api/v4/volunteer-group/volunteer-group'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request/request.types'
import { getConfig } from 'config/configuration'

const { endpoints } = getConfig()

const args: RequestArgs<ServerResponse, ClientResponse, VolunteerGroupParameters> = {
  method: 'GET',
  url: formatEndpoint(endpoints.api.v4.volunteerGroup),
  handleSuccess,
  handleFailure,
}

const volunteerGroupModule = () => createReduxServiceModule({ moduleName, args })

export default volunteerGroupModule
